module.exports = __webpack_public_path__ + "static/media/Palm_Island.829bd447.bmp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Palm_Island.bmp
// module id = 651
// module chunks = 0